@if (user?.id) {
    <app-card-table
        [columns]="experienceColumns"
        [tableTitle]="'user.editUser.labels.experience'"
        translatePrefix="user.editUser.experience."
        [hideCheckboxes]="true"
        [additionalFilter]="[[{ column: 'userId', operator: 'EQ', value: [user?.id || '-'] }]]"
        [gridData]="$any(store.data.getUserExperiences())"
        [refreshCallback]="store.api.getUserExperiences"
        (createCallback)="experienceDetail()"
        (detailCallback)="experienceDetail($event)"
        (deleteCallbackWithEvent)="deleteExperience($event)"
        [showCreate]="canEdit"
        [showDetail]="canEdit"
        [showDelete]="canEdit"
        [defaultSorters]="[{ column: 'date', direction: 'DESC' }]"
    >
    </app-card-table>
}
